import React, { useState, useEffect } from "react";
import DropDownInput from "components/sales/Input/dropDownInput/dropDownInput";
import localization from "assets/localization/localization";
import Images from "assets/images/imageData";
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import DatePicker from 'components/sales/datePicker/datePicker';

const DCTransferFilter = ({ applyFilter }) => {
  const filterInputs = {
    vehicle_number: "",
    lead_status: "",
    submission_date: "",
  };

  const [filterFieldsData, setFilterFieldsData] = useState(filterInputs);
  const [listStatus, setListStatus] = useState("");

  useEffect(() => {
    (async () => {
      const roles = await JSON.parse(
        localStorage.getItem("applyFilter") &&
          localStorage.getItem("applyFilter")
      );
      const status = await JSON.parse(
        localStorage.getItem("statusFilter") &&
          localStorage.getItem("statusFilter")
      );
      if (roles && status) {
        setFilterFieldsData(roles);
        setListStatus(status);
      }
    })();
  }, []);

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        applyFilter(filterFieldsData);
        filterFieldsData &&
          localStorage.setItem("applyFilter", JSON.stringify(filterFieldsData));
        listStatus &&
          localStorage.setItem("statusFilter", JSON.stringify(listStatus));
      }}
    >

      <ConstantInput
        label={'Vehicle Number'}
        type="text"
        handleChange={(value) => {
            setFilterFieldsData({ ...filterFieldsData, vehicle_number: value });
        }}
      />

      <DropDownInput
        data={[
          { id: "LEAD CAPTURED", name: "LEAD CAPTURED" },
          { id: "QC DONE", name: "QC DONE" },
          { id: "PICKUP CONFIRMED", name: "PICKUP CONFIRMED" },
          { id: "LEAD RESCHEDULED", name: "LEAD RESCHEDULED" },
          { id: "AGENT ASSIGNED", name: "AGENT ASSIGNED" },
          { id: "TODAY'S APPOINTMENT", name: "TODAY'S APPOINTMENT" },
          { id: "DOCUMENTS COLLECTED", name: "DOCUMENTS COLLECTED" },
          { id: "PHYSICAL VALIDATION", name: "PHYSICAL VALIDATION" },
          { id: "RTO READY", name: "RTO READY" },
          { id: "RTO SUBMITTED", name: "RTO SUBMITTED" },
          { id: "PARTY PESHI", name: "PARTY PESHI" },
          { id: "TRANSFER COMPLETED", name: "TRANSFER COMPLETED" },
          { id: "DEFERRED", name: "DEFERRED" },
          { id: "TERMINATED", name: "TERMINATED" },
          ]}
        label={localization.status}
        value={filterFieldsData?.lead_status !== null ? filterFieldsData?.lead_status : ''}
        getIdValue={(val) => {
            setFilterFieldsData({
            ...filterFieldsData,
            lead_status: val.id,
            });
        }}
      />

          <DatePicker
            label={'Schd. Mnt. Date'}
            required={false}
            handleChange={(val) => {
              setFilterFieldsData(val, "submission_date");
            }}
          />

      <div className="btn-wrapper">
        <button disabled={false} type="submit" className="btn btn-primary">
          {localization.applyFilter}
          <img src={Images?.ArrowRight} alt="" />
        </button>
        <br />
        <br />
        <button
          onClick={() => {
            localStorage.setItem("applyFilter", JSON.stringify(filterInputs));
            applyFilter(filterInputs);
            localStorage.setItem("statusFilter", JSON.stringify({}));
          }}
          type="button"
          className="btn btn-primary"
        >
          {localization.removeFilter}
        </button>
      </div>
    </form>
  );
};

export default DCTransferFilter;
